module.exports = __webpack_public_path__ + "static/media/appointment-reminders.51d936fe.png";